export enum TranslationType {
  ChartTemplate = 'ChartTemplate',
  PowerBiReport = 'PowerBiReport',
  Visualization = 'Visualization',
  SpiderVisu = 'SpiderVisu',
}
